import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { ExternalLink, LayoutDashboard } from "lucide-react";

// Admin Dashboard inside the Live room (same-origin iframe) so the host can
// reach admin tools without closing the broadcast. Opening a new tab on iPhone
// would suspend the camera, so the dashboard loads in-place instead.
export default function LiveRoomAdminDrawer({ open, onOpenChange }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="h-[92dvh] p-0 bg-zinc-950 border-t border-white/10 text-white flex flex-col" data-testid="live-admin-drawer">
        <SheetHeader className="px-4 pt-3 pb-2 border-b border-white/10 flex-row items-center justify-between space-y-0">
          <SheetTitle className="text-white text-sm flex items-center gap-2">
            <LayoutDashboard size={16} className="text-rose-300" /> Admin Dashboard
            <span className="text-[10px] font-normal text-emerald-300 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-2 py-0.5" data-testid="live-admin-drawer-live-badge">Your Live keeps running</span>
          </SheetTitle>
          <a href="/admin" target="_blank" rel="noreferrer" className="hidden md:flex items-center gap-1 text-[11px] text-zinc-400 hover:text-white mr-8" data-testid="live-admin-drawer-newtab">
            <ExternalLink size={12} /> New tab
          </a>
        </SheetHeader>
        {open && (
          <iframe title="Admin Dashboard" src="/admin?embed=1" className="flex-1 w-full min-h-0 bg-black" data-testid="live-admin-drawer-frame" />
        )}
      </SheetContent>
    </Sheet>
  );
}
